import { Box, Paper, Typography } from "@mui/material";

// `direction="column"` stacks the action under the message instead of beside it.
const EmptyWithAction = ({ message = "Няма намерени резултати.", direction = "row", children }) => {
  return (
    <Paper sx={{ mt: 5 }}>
      <Box
        p={2}
        sx={{
          display: "flex",
          flexDirection: direction,
          justifyContent: "center",
          alignItems: "center",
          gap: direction === "column" ? 1 : 3,
        }}
      >
        <Typography
          align="center"
          color="secondary"
        >
          {message}
        </Typography>
        {children}
      </Box>
    </Paper>
  );
};

export default EmptyWithAction;
